import React from 'react';

/**
 * Node-RED-inspired flow icon for pipelines (monochrome, inherits currentColor).
 */
const PipelineIcon = React.forwardRef(function PipelineIcon({ size = 16, ...rest }, ref) {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...rest}
    >
      <rect x="3" y="12" width="9" height="8" rx="1.5" fill="currentColor" />
      <rect x="20" y="4" width="9" height="8" rx="1.5" fill="currentColor" />
      <rect x="20" y="20" width="9" height="8" rx="1.5" fill="currentColor" />
      <path
        d="M12 16h4.5V8h3.5M16.5 16v5h3.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default PipelineIcon;
